module.exports = __webpack_public_path__ + "img/cattunnel33.2dd844d2.jpg";